import type { Experience, GuideAvatar, Photo } from '@experience/exp-card/dist/types/experience';

import type { ExperiencesListItem, GeoListItem, PhotoItem } from '@/shared/api/experience';

export const mapExperienceData = (item: ExperiencesListItem): Experience => ({
  id: item?.id,
  title: item?.title,
  text: '', // ?
  tagline: item?.tagline,
  annotation: item?.annotation,
  url: item?.url,
  type: item?.type,
  format: item?.format,
  grade: item?.grade,
  movement_type: item?.movement_type,
  schedule_type: item?.schedule_type,
  status: item?.status,
  is_instant_booking: item?.is_instant_booking,
  is_new: item?.is_new,
  max_persons: item?.max_persons,
  duration: item?.duration,
  price: {
    value: item?.price.value,
    currency: item?.price.currency,
    currency_rate: item?.price.currency_rate,
    price_from: item?.price.price_from,
    unit_string: item?.price.unit_string,
    value_string: item?.price.value_string,
  },
  rating: item?.rating,
  rating20: 0, // ?
  review_count: item?.review_count,
  geo: {
    city:
      item.geo.city?.map((cityItem: GeoListItem) => ({
        id: cityItem?.id,
        slug: cityItem?.slug,
        name: cityItem?.name,
        name_ru: cityItem?.name, // ?
        in_obj_phrase: cityItem?.in_obj_phrase,
        from_obj_phrase: cityItem?.from_obj_phrase,
        across_obj_phrase: cityItem?.across_obj_phrase,
        url: '', // ?
      })) ?? [],
    country:
      item.geo.country?.map((countyItem: GeoListItem) => ({
        id: countyItem?.id,
        slug: countyItem?.slug,
        name: countyItem?.name,
        in_obj_phrase: countyItem?.in_obj_phrase,
        from_obj_phrase: countyItem?.from_obj_phrase,
        across_obj_phrase: countyItem?.across_obj_phrase,
      })) ?? [],
  },
  guide: {
    id: item?.guide.id,
    first_name: item?.guide.first_name,
    url: item?.guide.url,
    avatar: item?.guide.avatar as GuideAvatar,
    rating: item?.guide.rating,
    rate_count: item?.guide.rate_count,
    review_count: item?.guide.review_count,
    avg_reaction_delay: item?.guide.avg_reaction_delay as number,
    type: item?.guide.type,
    date_start_work: item?.guide.date_start_work,
    date_joined: item?.guide.date_joined,
    is_licensed: item?.guide.is_licensed,
    orders_count: item?.guide.orders_count,
    visitors_count: item?.guide.visitors_count,
  },
  photos:
    item?.photos.map(
      (photo: PhotoItem): Photo => ({
        type: photo.type,
        thumbnail: photo.thumbnail,
        medium: photo.medium,
        thumbnail_s: photo.thumbnail,
        thumbnail_m: photo.thumbnail,
        thumbnail_l: photo.medium,
        thumbnail_xl: photo.medium,
      }),
    ) ?? [],
  schedule: {
    upcoming_events: item?.schedule.upcoming_events,
  },
  is_paid: item?.is_paid,
  show_promotion_badge: item?.show_promotion_badge ?? false,
  legal_exp_type: item?.legal_exp_type ?? null,
  accommodation: item?.accommodation
    ? {
        paid_separately: item.accommodation.paid_separately ?? false,
      }
    : null,
  // meeting_point ?
  // discount ?
});
